<template>
  <div class="d-md-none">
    <a
      :class="{
        button: true,
        'd-none': menuOpen,
      }"
      :style="{
        '--font-color': getContrastYIQ($root.color_schema.primary)
          ? '#333'
          : '#fff',
      }"
      @click="openMobMenu"
    >
      <svg
        class="menu-bars"
        width="24"
        height="16"
        viewBox="0 0 24 16"
        :fill="getContrastYIQ($root.color_schema.primary) ? '#333' : '#fff'"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 16H24V13.3333H0V16ZM0 9.33333H24V6.66667H0V9.33333ZM0 0V2.66667H24V0H0Z"
        />
      </svg>
    </a>
    <a
      :class="{
        'button menu-opened': true,
        'd-none': !menuOpen,
      }"
      :style="{
        '--font-color': getContrastYIQ($root.color_schema.primary)
          ? '#333'
          : '#fff',
      }"
      @click="closeMobMenu"
    >
      <span
        class="menu-close"
        :style="{
          color: getContrastYIQ($root.color_schema.primary) ? '#333' : '#fff',
        }"
        >&times;</span
      >
    </a>
    <nav
      id="mob-menu"
      :style="{
        '--primary-color': $root.color_schema.primary,
        '--top': getHeaderHeight(
          regulationBanner,
          carnivalBanner,
          regulationBannerSticky
        ),
        '--font-color': getContrastYIQ($root.color_schema.primary)
          ? '#333'
          : '#fff',
      }"
    >
      <ul>
        <li>
          <a
            class="search search-bg"
            :style="{
              '--primary-search-bg': pSBC(0.4, $root.color_schema.primary),
              '--search-icon': `url(${$root.site_url}${$root.asset_path}/svg-icons/search-sml.svg)`,
            }"
          >
            <input
              type="search"
              class="search-bg"
              :placeholder="$root.i18n.search"
              v-model="searchText"
              @keyup.enter="searchItem"
            />
          </a>
        </li>
        <li v-for="menu in menus" :key="menu.ID">
          <template v-if="menu.children && menu.children.length > 0">
            <a class="page-links">
              <img
                width="17"
                height="17"
                :src="menu.menu_item_icon"
                :alt="getAltText(menu.title, menu.menu_item_icon)"
                class="grayscale-invert"
              />
              <span>{{ menu.title }}</span>
            </a>
            <MobileChildMenu
              @closePanel="closeMobMenu"
              :menus="menu.children"
              :parent="menu"
            />
          </template>
          <template v-else>
            <template v-if="menu.object === 'custom'">
              <a
                class="page-links"
                v-if="menu.url && menu.url != ''"
                :href="menu.url"
              >
                <img
                  width="17"
                  height="17"
                  :src="menu.menu_item_icon"
                  :alt="getAltText(menu.title, menu.menu_item_icon)"
                  class="grayscale-invert"
                />
                <span>{{ menu.title }}</span>
              </a>
              <template v-else>
                <img
                  width="17"
                  height="17"
                  :src="menu.menu_item_icon"
                  :alt="getAltText(menu.title, menu.menu_item_icon)"
                  class="grayscale-invert"
                />
                <span>{{ menu.title }}</span>
              </template>
            </template>
            <template v-else>
              <template v-if="$root.enable_piwik_reload">
                <a
                  :href="getRouteLink(menu.slug, menu.object, menu.base_slug)"
                  @click="closeMobMenu"
                  class="page-links"
                >
                  <img
                    width="17"
                    height="17"
                    :src="menu.menu_item_icon"
                    :alt="getAltText(menu.title, menu.menu_item_icon)"
                    class="grayscale-invert"
                  />
                  <span>{{ menu.title }}</span>
                </a>
              </template>
              <template v-else>
                <router-link
                  :to="getRouteLink(menu.slug, menu.object, menu.base_slug)"
                  @click.native="closeMobMenu"
                  class="page-links"
                >
                  <img
                    width="17"
                    height="17"
                    :src="menu.menu_item_icon"
                    :alt="getAltText(menu.title, menu.menu_item_icon)"
                    class="grayscale-invert"
                  />
                  <span>{{ menu.title }}</span>
                </router-link>
              </template>
            </template>
          </template>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import MobileChildMenu from "./MobileChildMenu";
import Mmenu from "mmenu-js/src/mmenu";
import "mmenu-js/dist/mmenu.polyfills";
import router from "@/router";
import { pSBC, getContrastYIQ } from "@/misc/misc-function";

export default {
  name: "HeaderMobMenu",
  props: [
    "menus",
    "regulationBanner",
    "carnivalBanner",
    "regulationBannerSticky",
  ],
  data: function () {
    return {
      searchText: "",
      menuOpen: false,
      api: {},
    };
  },
  mounted: function () {
    // if (window.innerWidth < 991) {
    //   this.onLoad();
    // }
    // window.addEventListener("resize", () => {
    //   this.onLoad();
    //   let windowWidth = window.innerWidth;
    //   if (!this.smallCardView && windowWidth >= 768) {
    //     this.smallCardView = true;
    //   }
    // });
    const menu = new Mmenu("#mob-menu", {
      offcanvas: true,
    });
    this.api = menu.API;
    // Remove href for all button
    document.querySelectorAll("a[href^='#mm']").forEach((ele) => {
      let val = ele.getAttribute("href");
      ele.removeAttribute("href");
      ele.setAttribute("opentab", val);
      let pageLinkNode = ele.parentNode.querySelector(".page-links");
      if (pageLinkNode) {
        pageLinkNode.setAttribute("opentab", val);
      }
    });

    document.querySelectorAll("a[href='#app']").forEach((ele) => {
      ele.removeAttribute("href");
      ele.setAttribute("opentab", "#app");
    });

    // Open Close panel for opentab
    document.querySelectorAll("a[opentab^='#mm']").forEach((ele) =>
      ele.addEventListener("click", () => {
        let val = ele.getAttribute("opentab");
        this.api.openPanel(document.querySelector(val));
      })
    );
    // Replace Back to Menu title
    document.querySelectorAll(".mm-navbar__title span").forEach((ele) => {
      if (this.$root.i18n.back_to_menu) {
        ele.innerText = this.$root.i18n.back_to_menu.toUpperCase();
      }
    });

    var that = this;
    document.body.addEventListener("click", function (event) {
      let menuDOM = document.getElementById("mob-menu");
      let headerDOM = document.getElementById("header");
      if (
        that.menuOpen &&
        event.target != menuDOM &&
        !menuDOM.contains(event.target) &&
        event.target != headerDOM &&
        !headerDOM.contains(event.target)
      ) {
        that.closeMobMenu();
      }
    });
  },
  components: {
    MobileChildMenu,
  },
  methods: {
    pSBC,
    getContrastYIQ,
    closeMobMenu: function () {
      this.menuOpen = false;
      this.$emit("menuOpen", false);
      if (this.menuOpen) {
        this.api.open();
      } else {
        this.api.close();
      }
    },
    openMobMenu: function () {
      this.menuOpen = true;
      this.$emit("menuOpen", true);
      if (this.menuOpen) {
        this.api.open();
      } else {
        this.api.close();
      }
    },
    searchItem: function () {
      this.closeMobMenu();
      router
        .push({ name: "search", params: { searchText: this.searchText } })
        .catch((err) => {});
    },
    getHeaderHeight: function (regBanner, carBanner, regBannerSticky) {
      let headerDom = document.getElementById("header");
      if (headerDom) {
        if (carBanner && document.getElementById("carnival-banner")) {
          if (regBanner && document.getElementById("regulation-banner")) {
            return `${
              document.getElementById("carnival-banner").offsetHeight +
              document.getElementById("regulation-banner").offsetHeight +
              headerDom.offsetHeight +
              (regBannerSticky &&
              document.getElementById("sticky-regulation-banner")
                ? document.getElementById("sticky-regulation-banner")
                    .offsetHeight
                : 0)
            }px`;
          } else {
            return `${
              document.getElementById("carnival-banner").offsetHeight +
              headerDom.offsetHeight +
              (regBannerSticky &&
              document.getElementById("sticky-regulation-banner")
                ? document.getElementById("sticky-regulation-banner")
                    .offsetHeight
                : 0)
            }px`;
          }
        } else {
          if (regBanner && document.getElementById("regulation-banner")) {
            return `${
              document.getElementById("regulation-banner").offsetHeight +
              headerDom.offsetHeight +
              (regBannerSticky &&
              document.getElementById("sticky-regulation-banner")
                ? document.getElementById("sticky-regulation-banner")
                    .offsetHeight
                : 0)
            }px`;
          } else {
            return `${
              headerDom.offsetHeight +
              (regBannerSticky &&
              document.getElementById("sticky-regulation-banner")
                ? document.getElementById("sticky-regulation-banner")
                    .offsetHeight
                : 0)
            }px`;
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.d-none {
  display: none;
}

.search {
  background-color: var(--primary-search-bg);
  padding: 5px 30px;
  margin: 10px 6px;
  width: 100%;
  box-sizing: border-box;
  border: 0;
  border-radius: 5px;
  font-size: 16px;
  input {
    width: 100%;
    background-color: var(--primary-search-bg);
    border-width: 0;
    color: @black;
    &::placeholder {
      color: @black;
    }
  }
  &:before {
    position: absolute;
    left: 12px;
    content: "";
    top: 20px;
    background: var(--search-icon) no-repeat;
    width: 12px;
    height: 12px;
    z-index: 1;
  }
}

.button {
  width: 44px;
  position: absolute;
  left: 0px;
  top: -6px;
  cursor: pointer;
  z-index: 12399994;
  @media (min-width: @sizes[large]) {
    display: none;
  }
}

.page-links {
  color: #191923 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: inherit;
  display: block;
  padding: 15px 20px 15px 11px;
  margin: 0;
  flex-grow: 1;
  flex-basis: 10%;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  font-family: var(--default-regular);
  img {
    max-height: 17px;
    max-width: 17px;
  }
}

.grayscale-invert {
  filter: grayscale(1) invert(1);
  -webkit-filter: grayscale(1) invert(1);
}

.mt-10 {
  margin-top: 10px;
}

.menu {
  &-bars,
  &-close {
    height: 16px;
    margin-top: 22px;
  }
  &-close {
    font-size: 42px;
    line-height: 100%;
    font-weight: 700;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/HeaderMobMenu/HeaderMobMenu.vue